/** @jsxImportSource @emotion/react */
import { HelpCircle, Settings } from 'lucide-react';
import React from 'react';
import type { DivProps } from '../../../../../../typings';
import { Pages } from 'modules/navigation/domain/enums/pages';
import MenuItemIcon from '../menu-item/menu-item';
import * as S from './styles';

interface IProps extends DivProps {}

const MenuTechnical = React.memo(function MenuTechnicalIcon(props: IProps) {
  const { ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <MenuItemIcon to={Pages.SETTINGS.INDEX} icon={<Settings size={16} />} label={'Настройки'} />
      <MenuItemIcon to={'/help'} icon={<HelpCircle size={16} />} label={'Помощь'} disabled tooltip="В разработке" />
    </S.MainBlock>
  );
});

export default MenuTechnical;
